"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uriValidationError_1 = require("./uriValidationError");
var parse = require("url-parse");
var URIParser = /** @class */ (function () {
    function URIParser(uri) {
        this.uri = uri;
    }
    URIParser.prototype.parse = function () {
        var result = parse(this.uri, false);
        var scheme = result.protocol.replace(':', '');
        var defaultPort = scheme === 'http' ? 80 : 443;
        this.validate(result.host, scheme);
        return {
            host: result.hostname,
            path: result.pathname || '/',
            port: Number(result.port || defaultPort),
            query: result.query,
            scheme: scheme,
        };
    };
    URIParser.prototype.validate = function (host, scheme) {
        if (!host || (host.includes(':') && !host.includes('localhost')) || !['http', 'https'].includes(scheme)) {
            throw new uriValidationError_1.URIValidationError("Invalid uri " + this.uri);
        }
    };
    return URIParser;
}());
exports.URIParser = URIParser;
//# sourceMappingURL=uriParser.js.map